<template>
  <div>
    <section class=" container section is-main-section">
      <div>
        <v-card-component title="Weightage % Modification">
          <v-col>
            <v-card-actions>
              <router-link slot="right" :to="{ name: 'amsConfiguration' }">
                <v-btn
                  elevation="1"
                  absolute
                  right
                  top
                >
                  <v-icon left>mdi-arrow-left</v-icon>back</v-btn
                >
              </router-link>
            </v-card-actions>
          </v-col>
          <v-row>
            <v-col>
              <v-row>
                <v-col cols="12" lg="6" md="6">
                  <span class="body-2 font-weight-medium"> Weightage % of Retention (Excluding PP2) <span class="error--text ml-1">*</span></span>
                  <v-text-field v-model="retention" required class="my-0 py-1" type="number" min="0" max="100"
                  :rules="[v => v >= 0 || 'Value must be greater than 0', v => v <= 100 || 'Value must be 100 or less']">
                  </v-text-field>
                </v-col>
                <v-col cols="12" lg="6" md="6">
                  <span class="body-2 font-weight-medium"> Weightage % of Total Strength <span class="error--text ml-1">*</span></span>
                  <v-text-field v-model="totalStrength" required class="my-0 py-1" type="number" min="0" max="100"
                  :rules="[v => v >= 0 || 'Value must be greater than 0', v => v <= 100 || 'Value must be 100 or less']">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" lg="6" md="6">
                  <span class="body-2 font-weight-medium"> Weightage % of Parents (NPS) <span class="error--text ml-1">*</span></span>
                  <v-text-field v-model="parents" required class="my-0 py-1" type="number" min="0" max="100"
                  :rules="[v => v >= 0 || 'Value must be greater than 0', v => v <= 100 || 'Value must be 100 or less']">
                  </v-text-field>
                </v-col>
                <v-col cols="12" lg="6" md="6">
                  <span class="body-2 font-weight-medium"> Weightage % of Teachers <span class="error--text ml-1">*</span></span>
                  <v-text-field v-model="teachres" required class="my-0 py-1" type="number" min="0" max="100"
                  :rules="[v => v >= 0 || 'Value must be greater than 0', v => v <= 100 || 'Value must be 100 or less']">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row style="margin: 5px;">
            <button class="button is-success" @click="saveData()" type="submit" style="margin-top:20px;">Save</button>
            <button class="button is-success" @click="cancelData()" type="submit" style="margin-top:20px; margin-left: 15px;">Cancel</button>
          </v-row>
        </v-card-component>
      </div>
    </section>
    <section class=" container section is-main-section">
      <v-data-table
        item-key="id"
        :headers="headers"
        :items="weightageModification"
      ></v-data-table>
    </section>
  </div>
</template>

<script>
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import moment from 'moment'

export default {
  name: 'weightageModification',
  components: {
    VCardComponent
  },
  data () {
    return {
      retention: 0,
      totalStrength: 0,
      parents: 0,
      teachres: 0,
      weightageModification: [],
      headers: [
        {
          text: 'Retention (PP2)',
          value: 'retention',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Total Strength',
          value: 'totalStrength',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Parents (NPS)',
          value: 'parentNps',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Teachers',
          value: 'teachers',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Created By',
          value: 'createdBy',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Created Date',
          value: 'createdAt',
          sortable: true,
          align: 'center'
        }
      ]
    }
  },
  created: async function () {
    await this.getWeightageModification()
  },
  methods: {
    saveData: async function (con) {
      try {
        if (Number(this.retention < 0 || this.retention === '' || this.retention > 100)) {
          return this.$buefy.dialog.alert({
            message: 'Weightage % of Retention (Excluding PP2) must be between 0 and 100',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        if (Number(this.totalStrength < 0 || this.totalStrength === '' || this.totalStrength > 100)) {
          return this.$buefy.dialog.alert({
            message: 'Weightage % of Total Strength be between 0 and 100',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        if (Number(this.parents < 0 || this.parents === '' || this.parents > 100)) {
          return this.$buefy.dialog.alert({
            message: 'Weightage % of Parents (NPS) must be between 0 and 100',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        if (Number(this.teachres < 0 || this.teachres === '' || this.teachres > 100)) {
          return this.$buefy.dialog.alert({
            message: 'Weightage % of Teachres must be between 0 and 100',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        if (con !== 'yes') {
          this.confirmationMes()
          return
        }
        let response = await http.post(
          `${constants.API_URL}/api/amsScheduling/configuration/weightageModification/addWeightageModification`,
          {
            'retention': Number(this.retention),
            'totalStrength': Number(this.totalStrength),
            'parentNps': Number(this.parents),
            'teachers': Number(this.teachres)
          }
        )
        console.log(response, 'response')
        if (response.data.status === 200) {
          this.retention = 0
          this.totalStrength = 0
          this.parents = 0
          this.teachres = 0
          this.getWeightageModification()
          return this.$buefy.dialog.alert({
            type: 'is-info',
            message: response.data.message,
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
      } catch (e) {
        console.log(e)
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    async confirmationMes (item) {
      this.$dialog.confirm({
        text: 'Did you want to save Weightage ?',
        title: 'Confirm',
        type: 'error',
        actions: {
          false: {
            color: 'error',
            text: 'No',
            handle: () => {
              this.$nextTick(() => {
                return false
              })
            }
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              this.saveData('yes')
            }
          }
        }
      })
    },
    cancelData: async function () {
      this.retention = 0
      this.totalStrength = 0
      this.parents = 0
      this.teachres = 0
    },
    getWeightageModification: async function () {
      try {
        let response = await http.get(
          `${constants.API_URL}/api/amsScheduling/configuration/weightageModification/getWeightageModification`
        )
        console.log(response, 'response')
        this.weightageModification = response.data

        this.retention = this.weightageModification[0].retention
        this.totalStrength = this.weightageModification[0].totalStrength
        this.parents = this.weightageModification[0].parentNps
        this.teachres = this.weightageModification[0].teachers

        for (const item of this.weightageModification) {
          console.log(item, 'itrm---------')
          item.createdAt = item.createdAt ? moment(item.createdAt).format('DD/MM/YYYY') : ''
        }
      } catch (error) {
        console.log(error, 'error')
        return this.$buefy.dialog.alert({
          message: 'Error while fetching data',
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    }
  }

}
</script>
